module.exports = __webpack_public_path__ + "static/media/survey.3d7a5b55.svg";